import { render } from "./ConfirmModal2.vue?vue&type=template&id=c26d527a&ts=true"
import script from "./ConfirmModal2.vue?vue&type=script&lang=ts"
export * from "./ConfirmModal2.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__